module.exports = __webpack_public_path__ + "static/media/engines_Filipek.6fa9b3ff.png";